import { NEWS_MODE_LABELS } from '../../constants';
import type { NewsMode } from '../../types';

interface NewsModeToggleProps {
  value: NewsMode;
  onChange: (mode: NewsMode) => void;
}

const options: NewsMode[] = ['political', 'general'];

const NewsModeToggle = ({ value, onChange }: NewsModeToggleProps) => (
  <div className="toggle-group compact">
    {options.map((option) => (
      <button
        key={option}
        className={option === value ? 'active' : ''}
        onClick={() => onChange(option)}
      >
        {NEWS_MODE_LABELS[option]}
      </button>
    ))}
  </div>
);

export default NewsModeToggle;
